'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconHome, iconHomeTag } from '@ni/nimble-components/dist/esm/icons/home';
import { wrap } from '../../utilities/react-wrapper';

export type { IconHome };
export { iconHomeTag };
export const NimbleIconHome = wrap(IconHome);